export default __webpack_public_path__ + "static/media/warning.7ccfe21e.svg";